module.exports = __webpack_public_path__ + "static/media/IMG_1816.c22981b3.jpg";